// eslint-disable-next-line strict
module.exports = require('form-data');



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/classes/FormData.js
// module id = 667
// module chunks = 1